import { reduce } from './';
var decisionItem = function decisionItem(node, schema) {
  var result = [];
  var previousNodeType = '';
  node.forEach(function (n) {
    var text = reduce(n, schema);
    if (previousNodeType === 'mention' && !text.startsWith(' ')) {
      result.push(" ".concat(text));
    } else {
      result.push(text);
    }
    previousNodeType = n.type.name;
  });
  return "<> ".concat(result.join('').trim());
};
export default decisionItem;